import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      users: [{
        name: 'Admin',
        username: 'admin',
        password: 'admin123'
      }, {
        name: 'Editor',
        username: 'editor',
        password: 'editor'
      }, {
        name: 'User1',
        username: 'user1',
        password: 'user1'
      }],
      // 表单
      formLogin: {
        username: 'admin',
        password: '',
        code: 'v9am'
      },
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },

    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },

    /**
     * @description 提交表单
     */
    // 提交登录信息
    submitMock: function submitMock() {
      var _this2 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          _this2.login({
            username: _this2.formLogin.username,
            password: _this2.formLogin.password
          }).then(function () {
            // 重定向对象不存在则返回顶层路径
            _this2.$router.replace(_this2.$route.query.redirect || '/');
          });
        } else {
          // 登录表单校验失败
          _this2.$message.error('表单校验失败，请检查');
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this3.login({
            username: _this3.formLogin.username,
            password: _this3.formLogin.password
          }).then(function () {
            _this3.$router.replace(_this3.$route.query.redirect || '/');
          });
        } else {
          _this3.$message.error('表单校验失败，请检查');
        }
      });
    }
  })
};